import { ListTable } from './ListTable';
import { registerTextCell } from './scenegraph/group-creater/cell-type';

registerTextCell();
export class ListTableSimple extends ListTable {}
